"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSSpecialPromotionsComponent = void 0;
const accountsettings_service_1 = require("../../services/accountsettings.service");
const _ = require("underscore");
class CSSpecialPromotionsComponent {
    constructor(accountDetailService) {
        this.accountDetailService = accountDetailService;
        this.SelectedList = [];
        this.selectedPromotions = new Array();
        this.selectedItem = new Array();
        this.promotionTypeList = [
            { name: 'Time Management', value: 'time', Checked: false },
            { name: 'Sports', value: 'sports', Checked: false },
            { name: 'Music & Media', value: 'music', Checked: false },
            { name: 'Family Solutions', value: 'family', Checked: false }
        ];
    }
    ngOnInit() {
        this.getSpecialPromotionList();
        this.showForm = true;
    }
    selectedItems(items) {
        this.selectedPromotions.push(items);
        this.selectedItem = _.uniq(this.selectedPromotions);
    }
    showSelectedPromotions() {
        for (let i = 0; i < this.promotionTypeList.length; i++) {
            for (let j = 0; j < this.selectedItem.length; j++) {
                if (this.selectedItem[j] === this.promotionTypeList[i].value) {
                    this.promotionTypeList[i]['Checked'] = true;
                }
            }
        }
    }
    getSpecialPromotionList() {
        this.accountDetailService.getSpecialPromotions().subscribe((info) => {
            this.promotionlist = info;
            if (this.promotionlist == null) {
                this.showEmptyMsg = true;
                this.selectedItem.length = 0;
            }
            else {
                this.showEmptyMsg = false;
                this.promotionlist = info;
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    submitPromotionInfo(value) {
        this.loader = true;
        this.SelectedList.length = 0;
        for (let i = 0; i < this.promotionTypeList.length; i++) {
            if (this.promotionTypeList[i].Checked) {
                this.SelectedList.push(this.promotionTypeList[i].value);
            }
        }
        this.accountDetailService.validateSpecialPromotions(this.SelectedList)
            .subscribe((res) => {
            this.loader = false;
            this.updateMessage = true;
            this.getSpecialPromotionList();
            this.showForm = true;
            // if (res.error !== undefined) {
            //    // this.errorMsg = res.error;
            // } else {
            // }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
}
exports.CSSpecialPromotionsComponent = CSSpecialPromotionsComponent;
//# sourceMappingURL=specialpromotions.component.js.map